module.exports = __webpack_public_path__ + "img/teaser_fallback-1440x560.0b90fb2.jpg";